exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i[class^=\"icon-\"] {\n  font-size: 16px;\n}\ni[class^=\"icon-email\"] {\n  font-size: inherit;\n  position: relative;\n  top: 1px;\n}\ni[class^=\"icon-password-on\"],\ni[class^=\"icon-arrow\"],\ni[class^=\"icon-website2\"] {\n  font-size: 12px ;\n}\ni[class^=\"icon-phonetext\"] {\n  position: relative;\n  top: 2px;\n}\n.gt-input-pre-icon .geetest-icons {\n  color: #93A2BB;\n}\n.gt-form-item-content-error .gt-form-item-error .gt-input-pre-icon .geetest-icons {\n  color: #D36B75;\n}\na {\n  text-decoration: none;\n  outline: 0;\n  cursor: pointer;\n  transition: color .2s ease;\n}\n* {\n  box-sizing: border-box;\n}\nbody {\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/index.less
// module id = 451
// module chunks = 14